<template>
  <v-color-picker
    v-bind="field"
    v-model="toEditVal"
    :label="label"
    :hide-inputs="disabled || readOnly"
    :hide-canvas="disabled || readOnly"
    :disabled="disabled || readOnly"
    @change="$emit('update:toEdit', toEditVal)"
    canvas-height="120"
  />
</template>

<script>

export default {
  name: 'ColorField',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    toEdit: {
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toEditVal: this.toEdit || '#000000'
    }
  },
  watch: {
    toEdit () {
      this.toEditVal = this.toEdit || '#000000'
    }
  }
}
</script>

<style scoped>
  .v-color-picker {
    margin-bottom: 1em;
  }
</style>
